import {createContext, useContext} from 'react';

import type {ThreadsApp} from './types';

export const ThreadsAppContext = createContext<ThreadsApp | null>(null);

export function useThreadsApp(): ThreadsApp {
  const app = useContext(ThreadsAppContext);

  if (!app) {
    throw new Error('useThreadsApp must be used within ThreadsAppProvider');
  }

  return app;
}
